import { Injectable } from '@angular/core';
import { ApolloQueryResult } from '@apollo/client/core';
import {
    emptyDatiqGeoSuggestion,
    emptyDatiqGeoSuggestionResponse,
    IDatiqGeoQuerystringParam,
    IDatiqGeoSuggestion,
    IDatiqGeoSuggestionResponse,
} from '@dat/datiq-core/models';
import { DatiqGraphqlApolloService } from '@dat/datiq-graphql';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { suggestionsGraphqlQuery } from '../models';
import { isArray, isEqual, kebabCase } from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class DatiqGeoLocationProxyService {
    constructor(private readonly _apolloService: DatiqGraphqlApolloService) {}

    public resolveGeoSuggestion(
        searchText: string,
    ): Observable<IDatiqGeoSuggestionResponse> {
        // with the migration away from the csb geo suggestion endpoint to BTX's
        // geo suggestion endpoint, all of the properties are exactly the same with the
        // exception that BTX's endpoint returns placeId rather than pointId. We are now
        // aliasing this field in our GraphQL query so that the interface within the iQ
        // application does not need to change
        if (!!searchText?.length) {
            return this._apolloService
                .getApollo()
                .query<{ suggestions: IDatiqGeoSuggestion[] }>({
                    query: suggestionsGraphqlQuery,
                    variables: {
                        searchText,
                    },
                })
                .pipe(
                    map(
                        (
                            result: ApolloQueryResult<{
                                suggestions: IDatiqGeoSuggestion[];
                            }>,
                        ) => {
                            return result?.data?.suggestions ?? [];
                        },
                    ),
                );
        }

        return of({ ...emptyDatiqGeoSuggestionResponse });
    }

    getFirstResult$(termSearch: string): Observable<IDatiqGeoSuggestion> {
        return this.resolveGeoSuggestion(termSearch).pipe(
            map(
                (response: IDatiqGeoSuggestionResponse): IDatiqGeoSuggestion =>
                    this.getResultResponseSuggestion(response, termSearch),
            ),
        );
    }

    getResultResponseSuggestion(
        response: IDatiqGeoSuggestionResponse,
        searchTerm: string,
    ): IDatiqGeoSuggestion {
        if (!isArray(response)) {
            return emptyDatiqGeoSuggestion;
        }
        return (
            response?.find(
                (suggestion) =>
                    kebabCase(suggestion.displayName) === kebabCase(searchTerm),
            ) ??
            response?.[0] ??
            emptyDatiqGeoSuggestion
        );
    }

    // NOTE: since this is depending on the FM suggestion service at this point,
    // I'm not going to write a method to build a longer querystring til i need to
    buildSearchTerm(searchterm: string): IDatiqGeoQuerystringParam {
        return { searchText: searchterm };
    }
}
